(function($) {
  $(document).ready(function() {
    if (
      $('form#registration-form').length ||
      $('form#profile-form').length
    ) {
      // Address

      $('#add-address').click(function() {
        // Get the last DIV which ID starts with ^= "another-address"
        var $div = $('div[id^="another-address-"]:last');

        // Read the Number from that DIV's ID (i.e: 1 from "another-address-1")
        var num = parseInt($div.prop('id').match(/\d+/g), 10);

        var $addressField = $('#address-' + num);

        if ($addressField && $addressField.val()) {
          // Increment the number by 1
          num++;

          // Clone it and assign the new ID (i.e: from num 4 to ID "another-address-4")
          var $clone = $div.clone().prop('id', 'another-address-' + num);

          // For each of the inputs inside the div, clear it's value and
          // increment the number in the 'name' attribute by 1
          $clone.find('input').each(function() {
            this.value = '';

            var name_number = this.name.match(/\d+/);
            name_number++;
            this.name = this.name.replace(/\[[0-9]\]+/, '[' + name_number + ']');

            var name_id = this.id.match(/\d+/);
            name_id++;
            this.id = this.id.replace(/[0-9]/, name_id);

            var label_for = $(this).prev('label').attr('for');
            label_for = label_for.replace(/[0-9]/, num);
            $(this).prev('label').attr('for', label_for);

            if ($(this).attr('name') === 'default_address') {
              $(this).prop('checked', false);
              $(this).attr('value', num);
            }
          });

          // Finally, insert $clone after the last div
          $div.after($clone);

          // Init address autocomplete for new address fields
          initAutocomplete();

          checkDeleteButton();
        }
      });

      $('#remove-address').click(function() {
        var $div = $('div[id^="another-address-"]:last');
        $div.remove();
        checkDeleteButton();
      });

      function checkDeleteButton() {
        var numItemsAddress = $('div[id^="another-address-"]').length;

        if (numItemsAddress > 1) {
          $('#remove-address').removeClass('d-none');
        } else {
          $('#remove-address').addClass('d-none');
        }
      }

      // Validation
      $('#registration-form').validate({
        errorElement: 'span',
        rules: {
          firstname: {
            required: true,
            minlength: 3,
          },
          lastname: {
            required: true,
            minlength: 3,
          },
          email: {
            required: true,
            email: true,
          },
          gender: {
            required: true,
          },
          language: {
            required: true,
          },
          password: {
            required: true,
            minlength: 8,
            // pwcheck: true,
          },
          birthday: {
            required: true,
          },
          'profile-picture' : {
            required: true,
          },
          'home-phone': {
            required: true,
          },
          'work-phone': {
            required: true,
          },
          'already-member': {
            required: true,
          },
          reject: {
            required: true,
          },
          disciplinary: {
            required: true,
          },
          justice: {
            required: true,
          },
          guilty: {
            required: true,
          },
          directory: {
            required: true,
          },
          'city-directory': {
            required: true,
          },
          'home-address': {
            required: true,
          },
          'home-city': {
            required: true,
          },
          'home-province': {
            required: true,
          },
          'home-postal-code': {
            required: true,
          },
          'consent-informations-yes': {
            required: true,
          },
          'consent-news-yes': {
            required: true,
          },
          'consent-privacy-policy': {
            required: true,
          },
          'consent-commitment-yes': {
            required: true,
          },
          'consent-yes': {
            required: true,
          },
        },
        messages: {
          firstname: {
            required: theme_js_vars.translations['required_field'],
          },
          lastname: {
            required: theme_js_vars.translations['required_field'],
          },
          email: {
            required: theme_js_vars.translations['required_field'],
          },
          gender: {
            required: theme_js_vars.translations['required_field'],
          },
          language: {
            required: theme_js_vars.translations['required_field'],
          },
          password: {
            required: theme_js_vars.translations['required_field'],
          },
          birthday: {
            required: theme_js_vars.translations['required_field'],
          },
          'profile-picture' : {
            required: theme_js_vars.translations['required_field'],
          },
          'home-phone': {
            required: theme_js_vars.translations['required_field'],
          },
          'work-phone': {
            required: theme_js_vars.translations['required_field'],
          },
          'already-member': {
            required: theme_js_vars.translations['required_field'],
          },
          reject: {
            required: theme_js_vars.translations['required_field'],
          },
          disciplinary: {
            required: theme_js_vars.translations['required_field'],
          },
          justice: {
            required: theme_js_vars.translations['required_field'],
          },
          guilty: {
            required: theme_js_vars.translations['required_field'],
          },
          directory: {
            required: theme_js_vars.translations['required_field'],
          },
          'city-directory': {
            required: theme_js_vars.translations['required_field'],
          },
          'home-address': {
            required: theme_js_vars.translations['required_field'],
          },
          'home-city': {
            required: theme_js_vars.translations['required_field'],
          },
          'home-province': {
            required: theme_js_vars.translations['required_field'],
          },
          'home-postal-code': {
            required: theme_js_vars.translations['required_field'],
          },
          'consent-informations-yes': {
            required: theme_js_vars.translations['required_field'],
          },
          'consent-news-yes': {
            required: theme_js_vars.translations['required_field'],
          },
          'consent-privacy-policy': {
            required: theme_js_vars.translations['required_field'],
          },
          'consent-commitment-yes': {
            required: theme_js_vars.translations['required_field'],
          },
          'consent-yes': {
            required: theme_js_vars.translations['required_field'],
          },
        }
      });

      // Submit Handler
      $('.form-submit').click(function(event) {
        event.preventDefault();
        var validation = $('#registration-form').valid();

        if (!validation) {
          $('.alert-message').show();
          $(window).scrollTop(0);
        } else {
          $('.alert-message').hide();
        }

        if (validation) {
          var formData = $('#registration-form').serialize();

          $('.waiting').addClass('show');

          $.ajax({
            url: ajax_object.ajaxurl,
            type: 'POST',
            data: {
              action: 'ajax_action_registration_validation',
              form: formData,
            },
            success: function(response) {
              ajaxData(response);
              $('.alert-message').hide();
            },
            error: function(response) {
              $('.waiting').removeClass('show');
              return false;
            },
          });

          function ajaxData(response) {
            var response = $.parseJSON(response);

            $('#username').val(response.username);
            $('#duplicate_name').val(response.duplicate_name);

            if (response.email) {
              $('.alert-message-email').show();
              $('.waiting').removeClass('show');
              $(window).scrollTop(0);
            } else {
              $('.alert-message').hide();
              $('.waiting').addClass('show');
              $('#registration-form').submit();
            }
          }
        }
      });

      // Image preview before upload
      $('#picture').change(function() {
        previewFile(this);
      });

      function previewFile(input) {
        var file = $('.picture input[type=file]').get(0).files[0];

        if (file) {
          var reader = new FileReader();

          reader.onload = function() {
            $('#previewImg').css(
              'background-image',
              'url(' + reader.result + ')',
            );
          };

          reader.readAsDataURL(file);
        }
      }

      /**
       * Files
       */
      var registrationForm = $('#registration-form');
      var mediaInput = registrationForm.find('#mediaInput');
      var mediaList = registrationForm.find('#mediaList');
      var fileIndex = 0;

      function addFileToList(input, filename) {
        if (!input || !filename) return false;

        var item = '';
        item += '<div id="item-' + fileIndex + '" class="item">';
        item += '<div class="item__header">';
        item += '<p class="item__name">' + filename + '</p>';
        item += '<button type="button" class="item__remove">';
        item += theme_js_vars.translations['remove'];
        item += '</button>';
        item += '</div>';
        item += '</div>';

        mediaList.append(item);
        mediaList.find('#item-' + fileIndex).append(input);

        mediaList.find('.item__remove').on('click', function () {
          $(this).parent().parent().remove();
        });

        return true;
      }

      function fileInputChangeHandler(fileInput) {
        var file = fileInput[0].files[0];

        if (file !== undefined) {
          var clonedInput = fileInput.clone();

          clonedInput.insertAfter(fileInput);
          clonedInput.val('');
          
          fileInput.attr('id', 'media-' + fileIndex);
          fileInput.attr('name', 'file[' + fileIndex + ']');
          fileInput.css('display', 'none');

          addFileToList(fileInput, file.name);

          clonedInput.on('change', function () {
            fileInputChangeHandler(clonedInput);
          });

          fileIndex += 1;

          $(this).val('');
        }
      }

      mediaInput.on('change', function () {
        fileInputChangeHandler($(this));
      });
    }
  });
})(jQuery);
